import { BigWinThresholds } from "ags/utils/win-magnitude";
import betModel from "slotworks/model/bets/bet-model";
import GameState from "slotworks/model/game-state";
import BonusResult from "slotworks/model/gameplay/records/results/bonus-result";
import { Exit } from "slotworks/state-machine/data/exit";
import Decision from "slotworks/state-machine/decisions/decision";

export default class OverAnimateThreshold extends Decision {

    public evaluate() {
        const record = GameState.getCurrentGame().getCurrentRecord();
        const winRatio = record.cashWon / betModel.getTotalStake();

        // Change as of BB-67 to always highlight after a pick bonus
        const isPickBonus = record.getResultsOfType(BonusResult).length > 0;

        return (winRatio >= BigWinThresholds.REGULAR || isPickBonus) ? Exit.True : Exit.False;
    }
}
